import { Box, lighten, Typography, useTheme } from '@material-ui/core';
import React from 'react';
import { IStoreTag } from 'src/constants/store/tags';

export const TagItem = ({
    tag,
    size = 'default',
}: {
    tag: IStoreTag;
    size: 'xs' | 'default';
}) => {
    const theme = useTheme();

    const { _id, color, icon, name } = tag;

    const styles = {
        default: {
            text: {
                fontSize: 12,
                color: theme.palette.getContrastText(color),
                display: 'flex',
                alignItems: 'center',
                gap: 3,
            },
            box: {
                backgroundColor: color,
                padding: '4px 8px',
                borderRadius: 15,
            },
        },
        xs: {
            text: {
                fontSize: 8,
                color: theme.palette.getContrastText(color),
                display: 'flex',
                alignItems: 'center',
                gap: 3,
            },
            box: {
                backgroundColor: color,
                padding: `4px 5px`,
                borderRadius: 15,
            },
        },
    };

    return (
        <Box key={_id} style={styles[size].box}>
            <Typography variant="caption" style={styles[size].text}>
                {size !== 'xs' && icon}
                {name}
            </Typography>
        </Box>
    );
};
